import { useMediaQuery } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { Grid } from '../';
import Page from './Page';
import DefaultPane from './Pane';
import type { TwoPaneProps } from './types';

export const TwoPane = ({
  bigQuery = (theme: Theme) => theme.breakpoints.up('xl'),
  List,
  Details,
  showDetails,
  // Always show the list, prevents showing only details on smaller devices
  alwaysShowList = false,
  Pane = DefaultPane,
  detailsRatio = 2 / 3,
}: TwoPaneProps) => {
  const big = useMediaQuery(bigQuery, { noSsr: true });

  if (showDetails && !big && !alwaysShowList) {
    return (
      <Page>
        <Pane>
          <Details fullScreen />
        </Pane>
      </Page>
    );
  }

  // small: 1 col
  // normal desktop: 2 col
  const viewPaneTwo = big && showDetails;
  const cssGridColumns = viewPaneTwo ? `1fr ${detailsRatio}fr` : '1fr';

  return (
    <Page>
      <Grid gap={0} columns={cssGridColumns} height="100%">
        <Pane>
          <List fullScreen={!big} />
        </Pane>
        {viewPaneTwo && (
          <Pane
            sx={{
              borderLeft: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Details fullScreen={false} />
          </Pane>
        )}
      </Grid>
    </Page>
  );
};
